import { AbstractControl } from '@angular/forms';

export function checkValidator(
  control: AbstractControl,
  type: string
): boolean {
  switch (type) {
  case 'special-character':
    // eslint-disable-next-line no-useless-escape
    return /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(control.value);
  case 'number':
    return /\d/.test(control.value);
  case 'lowercase':
    return /[a-z]/.test(control.value);
  case 'uppercase':
    return /[A-Z]/.test(control.value);
  case 'length':
    return control.value.length >= 8;
  default:
    return false;
  }
}
